import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { PlanCuidadoSearchContent } from './components/PlanCuidadoSearchContent';

export default function PlanCuidadoSearch() {

    return (
        <MainContent
            component={<PlanCuidadoSearchContent />}
            titulo='Busqueda de plan'
            tableMaxWidth={true}
        />
    );

};